module.exports = __webpack_public_path__ + "static/media/small-xl-alt_2x.4595c35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vehicles/small-xl-alt_2x.png
// module id = 670
// module chunks = 27